import {mixins} from "../app/mixin";

mixins.push({
    el: '.carbonManagementPage',
    data() {
        return {
            selectedProcess: 1,
            selectedWhatIsObject: 0
        }
    },
    methods: {
        selectProcess(processId) {
            if (this.selectedProcess !== processId) {
                this.selectedProcess = processId
            }
        },
        selectWhatIsObject(objectId) {
            if (this.selectedWhatIsObject !== objectId) {
                this.selectedWhatIsObject = objectId;
            }
        },
    },
});